/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type DreamJobsSetConsentDetailsMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type DreamJobsSetConsentDetailsMutation = {
  __typename?: 'Mutation';
  dreamJobsSetConsentDetails?:
    | { __typename?: 'DreamJobsConsentFetchSuccess' }
    | {
        __typename?: 'DreamJobsConsentSetSuccess';
        userId?: string | null;
        updatedAt?: string | null;
      }
    | { __typename?: 'DreamJobsDeleteSuccess' }
    | { __typename?: 'DreamJobsError' }
    | { __typename?: 'DreamJobsStoreSuccess' }
    | null;
};

export const DreamJobsSetConsentDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DreamJobsSetConsentDetails' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dreamJobsSetConsentDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'consentTaken' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'DreamJobsConsentSetSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DreamJobsSetConsentDetailsMutation,
  DreamJobsSetConsentDetailsMutationVariables
>;
